import styled from "styled-components";
import { Button } from "@chakra-ui/react";
import { SpinnerIcon } from "@chakra-ui/icons";

export const LoginWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
`;

export const LoginForm = styled.form`
  padding: 40px;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  border-radius: 10px;
  -webkit-box-shadow: 12px 13px 8px 0px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 12px 13px 8px 0px rgba(34, 60, 80, 0.2);
  box-shadow: 12px 13px 8px 0px rgba(34, 60, 80, 0.2);
`;

export const InputFields = styled.div`
  margin: 40px 0 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ButtonField = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  margin-top: 20px;
`;

export const ErrorText = styled.p`
  padding: 0;
  margin: 0;
  color: red;
  font-size: 14px;
`;
